import { Component, EventEmitter, Input, OnInit, SimpleChanges } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { ResultModel } from 'src/app/core/models/result.model';

@Component({
  selector: 'app-crop-image',
  templateUrl: './crop-image.component.html',
  styleUrls: ['./crop-image.component.scss']
})
export class CropImageComponent extends BaseComponent implements OnInit {

  @Input('fileEvent')
  fileEvent = null;

  @Input('fileEventChange')
  fileEventChange = new EventEmitter<void>();
  
  croppedImage = null;

  isUpdating: boolean = false;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.isUpdating = false;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cancel() {
    this.resetModel();
    this.onCancel.emit(new ResultModel(false, 'İptal edildi'));
  }

  update(){
    this.isUpdating = true;
    this.onResult.emit(new ResultModel(true, '', this.croppedImage));
  }

  resetModel() {
    // this.f.resetForm();
    setTimeout(
      () => {
        this.croppedImage = null;
      },
      500
    )
  }
}
